(function () {
  var BLOCKED_MSG = 'not qualified';
  var CART_COOKIES = ['cart', 'cart_sig', 'cart_ts', 'cart_ver', 'cart_currency'];

  function clearCart() {
    CART_COOKIES.forEach(function (n) {
      document.cookie = n + '=; Path=/; Max-Age=0; SameSite=Lax; Secure';
    });
    window.location.replace('/');
  }

  // --- 1. Handle ?clear-cart=1 or #clear-cart (link from validation error) ---
  var url = new URL(window.location.href);
  if (url.searchParams.has('clear-cart') || url.hash === '#clear-cart') {
    clearCart();
    return;
  }

  // --- 2. Surface the error inside the existing cart-messages alert ---
  function showRecoveryInCart(html) {
    var tries = 0;
    function apply() {
      if (!window.vueapp) return false;
      window.vueapp.cartError = html || true;
      // Cancel the Vue watcher's 5s auto-dismiss so the recovery stays visible.
      window.vueapp.$nextTick(function () {
        if (window.vueapp._cartErrorTimeout) {
          clearTimeout(window.vueapp._cartErrorTimeout);
          window.vueapp._cartErrorTimeout = null;
        }
      });
      return true;
    }
    if (apply()) return;
    var iv = setInterval(function () {
      if (apply() || ++tries > 50) clearInterval(iv);
    }, 100);
  }

  // --- 3. Proactive probe: catches shared-permalink / logged-in stuck carts
  //        on any page that exposes the cart (incl. sidecart on PDPs) ---
  function probe() {
    // Nothing to check if there's no cart cookie (empty session).
    if (!/(?:^|;\s*)cart=/.test(document.cookie)) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: '{}'
    }).then(function (res) {
      if (res.status !== 422) return;
      return res.json().then(function (b) {
        if (JSON.stringify(b || {}).indexOf(BLOCKED_MSG) === -1) return;
        showRecoveryInCart((b && (b.description || b.message)) || true);
      });
    }).catch(function (err) {
      console.warn('[cart-recovery] probe failed:', err);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', probe);
  } else {
    probe();
  }
})();
